import { RefObject, useEffect } from 'react';
import type { Editor } from '@tiptap/react';

import { FORM_FIELD_NODE_NAME } from '../tiptap/nodes/formField/constants';

/** Focuses the label of a field that insertion or Duplicate just added, once. */
const useFocusNewFieldLabel = (editor: Editor, fieldId: string | undefined, refLabel: RefObject<HTMLInputElement>) => {
  useEffect(() => {
    if (!fieldId || editor.storage[FORM_FIELD_NODE_NAME].focusLabelOfFieldId !== fieldId) return;
    editor.storage[FORM_FIELD_NODE_NAME].focusLabelOfFieldId = undefined;
    refLabel.current?.focus();
  }, [fieldId]);
};

export default useFocusNewFieldLabel;
